var portfolioTransactionsList = {
	caption: "Portfolio Transaktionen",
	date: "Datum",
	time: "Zeit",
	name: "Name",
	isin: "ISIN",
	transactionType: "Art",
	numberOfShares: "Anzahl/Nennwert",
	executionPrice: "Ausführungspreis",
	executionValue: "Ausführungswert",
	assetClass: "Anlageklasse",
	actions: "Aktionen",
	buy: "Kauf",
	sell: "Verkauf",
	cash: "Liquide Mittel",
	payout: "Auszahlung",
	short: "Short",
	cover: "Cover",
	noTransactions: "Keine Ergebnisse gefunden",
	bond: "Anleihe",
	commodity: "Rohstoff",
	currency: "Währung",
	debt: "Schuldtitel",
	etf: "ETF",
	fund: "Fonds",
	generic: "Sonstige",
	index: "Index",
	stock: "Aktie",
	interestRate: "Zinssatz",
	structuredProduct: "Strukturiertes Produkt",
	investmentProduct: "Anlageprodukt",
	leveragedProduct: "Gehebeltes Produkt",
	option: "Option",
	future: "Future"
};
var de = {
	portfolioTransactionsList: portfolioTransactionsList
};

export { de as default, portfolioTransactionsList };
